/**
 * DayValuePremiumPage — Premium version with extended analysis
 * Warm traditional theme
 */
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { getPaksham, PANCHANGAM_API } from '../services/panchangam-utils';
import PremiumGate from '../components/PremiumGate';

const T = {
  bgPage: '#f0f5e8', bgGreenPale: '#e8f5e9', bgCream: '#fffef0',
  textGreenDark: '#1b5e20', textGreenDeep: '#0d3b0f', textMaroon: '#6d1b1b',
  borderGreen: '#c8e6c9', gold: '#f0d48a',
  headerBg: 'linear-gradient(135deg, #090b72, #1a237e)',
};

const DayValuePremiumPage = () => {
  const [pd, setPd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [today, setToday] = useState(dayjs().format('YYYY-MM-DD'));

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(PANCHANGAM_API, { params: { date: today, time: '12pm' } });
      if (res.data[0]) setPd(res.data[0]);
    } catch { setPd(null); }
    finally { setLoading(false); }
  }, [today]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return (
    <PremiumGate feature="muhurtham" title="Premium தினமதிப்பு">
      <div style={{ padding: '10px', background: T.bgPage, minHeight: '80vh' }}>
        <div style={{ background: T.headerBg, padding: '14px', borderRadius: '12px', textAlign: 'center', marginBottom: '12px', borderBottom: '3px solid #ff9800' }}>
          <h2 style={{ color: 'white', margin: 0, fontSize: '1.1rem', fontWeight: 800 }}>👑 Premium தினமதிப்பு-விவாஹசிறப்பு</h2>
          <div style={{ color: T.gold, fontSize: '0.85rem', marginTop: '4px' }}>{today}</div>
        </div>
        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
          <input type="date" value={today} onChange={e => setToday(e.target.value)}
            style={{ padding: '8px 16px', borderRadius: '8px', border: `2px solid ${T.textGreenDark}`, fontSize: '1rem', background: T.bgCream }} />
        </div>
        {loading && <div style={{ textAlign:'center', padding:'40px', color:T.textGreenDark, fontWeight: 'bold' }}>Please wait ....</div>}
        {!loading && pd && (
          <div style={{ backgroundColor: T.bgGreenPale, borderRadius: '12px', padding: '14px', border: `1px solid ${T.borderGreen}` }}>
            <PRow label="பக்ஷம்-திதி" value={`${getPaksham(pd.PakshamNameInTamil, pd.Paksham)}-${pd.ThithiNameInTamil}`} />
            <PRow label="நக்ஷத்ரம்" value={pd.NakshatraNameInTamil} />
            <PRow label="யோகம்" value={pd.YogaNameInTamil} />
            <PRow label="கரணம்" value={pd.KaranamNameInTamil} />
            <PRow label="நேத்ரம்" value={pd.Nethram} />
            <PRow label="ஜீவன்" value={pd.Jeevan} />
            <PRow label="யோகினி" value={pd.Yogini} />
            <PRow label="விசேஷம்" value={pd.DaySpecialityInTamil || 'இல்லை'} />
            <div style={{ textAlign:'center', padding:'14px', marginTop:'10px', backgroundColor: T.bgCream, borderRadius:'8px', border: `1px solid ${T.borderGreen}` }}>
              <div style={{ fontWeight:800, color:T.textGreenDark }}>நேத்ரம்: {pd.Nethram} | ஜீவன்: {pd.Jeevan}</div>
              <div style={{ fontSize:'0.8rem', color:T.textMaroon, marginTop:'4px' }}>
                நேத்ரம் 2 = சிறந்த முஹூர்த்த நாள் | நேத்ரம் 0 = முஹூர்த்தம் தவிர்க்கவும்
              </div>
            </div>
          </div>
        )}
        {!loading && !pd && <div style={{ textAlign:'center', padding:'40px', color: T.textMaroon }}>தரவு கிடைக்கவில்லை</div>}
      </div>
    </PremiumGate>
  );
};

const PRow = ({ label, value }) => (
  <div style={{ display:'flex', borderBottom:'1px solid #c8e6c9', padding:'6px 0', fontSize:'0.9rem' }}>
    <div style={{ width:'35%', fontWeight:700, color:'#1b5e20' }}>{label}</div>
    <div style={{ width:'65%', color:'#0d3b0f' }}>{value}</div>
  </div>
);

export default DayValuePremiumPage;
